import { render } from "./Cropper.vue?vue&type=template&id=10fccdc9&scoped=true"
import script from "./Cropper.vue?vue&type=script&lang=js"
export * from "./Cropper.vue?vue&type=script&lang=js"

import "./Cropper.vue?vue&type=style&index=0&id=10fccdc9&scoped=true&lang=scss"

import exportComponent from "C:\\websites\\kroechkwis-dielnimmer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fccdc9"]])

export default __exports__